import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { extractArgs, parseConfig, drilldownToConfig } from '../utils';
import { getSessionId } from '../NexaStore';
import { HandlerOptions } from './types';
import { Tabs } from '@src/store/trends/base/reducer';

/**
 * Handles fetch_impacted_viewers_csv tool - uses standard dashboard flow
 * with custom toggle configuration for dimension-only view
 */
export const handleImpactedViewers = (options: HandlerOptions): void => {
  try {
    const { rawConfig, args, redirectHandler } = options;

    // Parse config using standard flow
    const parsedArgs = extractArgs(rawConfig || { args });
    const dashboardConfig = parseConfig(parsedArgs);

    // Customize toggles for impacted viewers view
    // Show only dimension table, hide summary and metric sections
    dashboardConfig.toggles = {
      sections: {
        summary: false,
        metric: false,
        dimension: true,
      },
    };

    // Set dimension panel to show the "Viewers" tab (TopImpactedViewers)
    dashboardConfig.dimensionPanel = {
      activeTab: Tabs.TopImpactedViewers,
    };

    const id = getSessionId();

    // Use standard drilldown flow
    drilldownToConfig({ dashboardConfig, id, redirectHandler });

    apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'impacted_viewers', id });
    logger.log('Opened impacted viewers dashboard with dimension-only view on Viewers tab');
  } catch (error) {
    logger.error('Error handling impacted viewers:', error);
  }
};
